const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class ChargeQueryConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async listCharges({ sort, page = 0, maxPerPage = 10, startCaptureDate, endCaptureDate, startRefundDate, endRefundDate, startDate, endDate, startPayoutDate, endPayoutDate, status, dispatchId, dynamicSearch, payoutId, timezone }) {
    try {
      const params = { sort, page, maxPerPage, startCaptureDate, endCaptureDate, startRefundDate, endRefundDate, startDate, endDate, startPayoutDate, endPayoutDate, status, dispatchId, dynamicSearch, payoutId, timezone };

      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/charges`, {
        params,
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async refundCharge({ chargeId, amount }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/charges/${chargeId}/refund`,
        method: 'POST',
        data: {
          amount,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async listPayouts(params) {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/payouts`, {
        params,
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  ChargeQueryConnector,
};
